import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormDropdown, FormFields, mapToDropdownOption, Stack } from "sprint-common-web";

import { AddSystemPlatformFormInputs } from "./AddSystemPlatformFormInputs";
import { useAddSystemPlatformForm } from "./useAddSystemPlatformForm";

export interface AddSystemPlatformFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export const AddSystemPlatformForm: React.VFC<AddSystemPlatformFormProps> = (props: AddSystemPlatformFormProps) => {
    const {
        integratorOptions,
        systemOptions,
        resetSystemOptions,
        createSystemPlatform,
        validateUniqueSystem
    } = useAddSystemPlatformForm();

    const { errors, control, formState, handleSubmit, setValue, watch } = useForm<AddSystemPlatformFormInputs>({
        defaultValues: {
            integratorId: "",
            systemId: ""
        },
        criteriaMode: "all"
    });

    const handleAddSystemPlatform = async (inputs: AddSystemPlatformFormInputs) => {
        await createSystemPlatform(inputs);
        props.onSubmit();
    };

    const handleCancelButtonClick = () => {
        props.onCancel();
    };

    const handleIntegratorSelected = (integratorId: string) => {
        if (integratorId) {
            resetSystemOptions(integratorId);
        }

        setValue("systemId", "");
    };

    return (
        <Form onSubmit={handleSubmit(handleAddSystemPlatform)}>
            <FormFields>
                <Stack>
                    <FormDropdown
                        options={integratorOptions.map((integrator) => mapToDropdownOption(integrator))}
                        control={control}
                        errors={errors}
                        rules={{ required: "Select Integrator from dropdown" }}
                        name="integratorId"
                        label="Integrator"
                        onChange={handleIntegratorSelected}
                    />
                    <FormDropdown
                        options={systemOptions.map((system) => mapToDropdownOption(system))}
                        control={control}
                        errors={errors}
                        rules={{
                            required: "Select System from dropdown",
                            validate: validateUniqueSystem
                        }}
                        disabled={!watch("integratorId")}
                        name="systemId"
                        label="System"
                    />
                </Stack>
            </FormFields>
            <FormActions
                isLoading={formState.isValidating || formState.isSubmitting}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
